import {
  columnSettings,
  defaultColumns
} from '@/angularBridgeCode/services/NumberPoolService';

export default {
  widget: {
    iconClass: 'typcn typcn-phone',
    title: ''
  },
  namespaced: true,
  numberPools: [], 
  dayStats: [],
  monthStats: [],
  numberPoolReferences: null,
  isNumberPoolReferencesLoading: false,
  columnSettings: columnSettings,
  userVisibleColumns: defaultColumns,
  currentAccountFeatureFlags: {},
  selectedNumberPool: null,
  status: {},
  pendingOrders: [],
  orders: [],
  selectedOrderId: '',
  selectedOrder: {},
  actionStatus: {}, 
  userSettings: {},
  numberCountries: []
};